const getBaseUrl = () => {
  if (window.HYBRID) {
    // if (window.location.host.includes("localhost")) {
    //   return `${window.location.protocol}//${window.location.hostname}:8000/`;
    // }
    return `${window.location.protocol}//back.educandus.com.br/`;
  }

  if (window.BACKEND) {
    return window.BACKEND;
  }

  const suffix = window.location.host.includes(".com.br") ? ".com.br" : ".net";

  if (window.location.host.includes("localhost")) {
    /* Backend local explícito, para desenvolver contra a própria máquina em
       qualquer porta — inclusive a 3000, que por padrão vai para homologação.

       Vive em .env.local, que está no .gitignore: a variável não existe em
       nenhum ambiente publicado, então lá o comportamento abaixo continua
       exatamente o mesmo. Ex.: REACT_APP_BACKEND=http://127.0.0.1:8000/ */
    if (process.env.REACT_APP_BACKEND) {
      return process.env.REACT_APP_BACKEND;
    }
    /* A 3000 vai para HOMOLOGAÇÃO, e o host é escrito por inteiro de propósito.
       Não usar o padrão `backhomologa.educandus${suffix}` daqui a algumas linhas:
       ele funciona no front PUBLICADO, que está em `.com.br`, mas em localhost o
       `suffix` cai em `.net` — e `backhomologa.educandus.net` NÃO EXISTE no DNS
       (conferido em 05/08/2026; só o `.com.br` resolve, em 193.123.113.3).

       Já esteve escrito com o padrão, entre 04 e 05/08/2026, e o efeito era
       apontar o dev local para PRODUÇÃO: `back.educandus.net` e
       `back.educandus.com.br` são o mesmo IP (193.123.106.90), o de
       `ava.educandus.com.br`. O sintoma foi atividade criada em homologação não
       aparecer, e a trilha lúdica não aparecer nunca — ela vive na develop, que
       está publicada em homologação e não em produção.

       O que torna isso pior que um endereço errado: `getLoginUrl` manda localhost
       para `homologa.login.educandus.com.br`. A sessão era de homologação e a API,
       de produção — um teste local escrevendo do outro lado.

       `http` e não `https`: o https de backhomologa não conecta (medido). */
    if (window.location.port === "3000") {
      return "http://backhomologa.educandus.com.br/";
    }
    return "http://localhost:8000/";
  }
  if (window.location.host.includes("homologa")) {
    return `${window.location.protocol}//backhomologa.educandus${suffix}/`;
  }
  if (window.location.host.includes("alfa")) {
    return `${window.location.protocol}//alfaback.educandus${suffix}/`;
  }
  if (window.location.host.includes("beta")) {
    return `${window.location.protocol}//betaback.educandus${suffix}/`;
  }

  return `${window.location.protocol}//back.educandus${suffix}/`;
};

const getExamMigrationUrl = () => {
  if (window.location.host.includes("localhost")) {
    return "https://homologa.adrbackend.educandus.com.br/ava/exam-migration-ava-adr";
  }

  if (window.location.host.includes("avahomologa.educandus.com.br")) {
    return "https://homologa.adrbackend.educandus.com.br/ava/exam-migration-ava-adr";
  }

  if (window.location.host.includes("ava.educandus.com.br")) {
    return "https://adrbackend.educandus.com.br/ava/exam-migration-ava-adr";
  }

  return "https://adrbackend.educandus.com.br/ava/exam-migration-ava-adr";
};

/* Base do backend do ADR (projeto adr/backend), usada pelas telas do AVA que
   leem dados de lá — hoje o relatório da avaliação diagnóstica
   (/evaluation/adr/report?type=diagnostic).

   O ADR aceita o AVA no CORS (localhost:3000, avahomologa e ava.educandus) e
   essas rotas de leitura não exigem token, então a chamada vai direta do
   navegador. */
const getAdrApiUrl = () => {
  /* Override explícito, para apontar o ADR para outro host/porta. Vive em
     .env.local, que está no .gitignore: a variável não existe em nenhum
     ambiente publicado.
     Ex.: REACT_APP_ADR_BACKEND=https://homologa.adrbackend.educandus.com.br/ */
  if (process.env.REACT_APP_ADR_BACKEND) {
    return process.env.REACT_APP_ADR_BACKEND;
  }

  /* Em desenvolvimento o ADR roda na máquina, na 3008 (PORT do adr/backend). */
  if (window.location.host.includes("localhost")) {
    // return "http://localhost:3008/";
    return "https://homologa.adrbackend.educandus.com.br/";
  }

  if (window.location.host.includes("homologa")) {
    return "https://homologa.adrbackend.educandus.com.br/";
  }

  return "https://adrbackend.educandus.com.br/";
};

const getLoginUrl = () => {
  if (
    window.location.host.includes("localhost") ||
    window.location.host.includes("homologa")
  ) {
    return "https://homologa.login.educandus.com.br/login?from=ava";
  }

  return "https://login.educandus.com.br/login?from=ava";
};

const baseUrl = getBaseUrl();
const loginUrl = getLoginUrl();

export default {
  /*
  // PRODUÇÃO
  interface : 'http://back.educandus.net/interface/interface.html',
  api : 'http://back.educandus.net/api/',
  img : 'http://back.educandus.net/',
  node: 'https://educandus-node.herokuapp.com/',
  public : 'http://back.educandus.net/',

  // HOMOLOGAÇÃO
  interface: "http://back.homologa.educandus.com.br/interface/interface.html",
  api: "http://back.homologa.educandus.com.br/api/",
  img: "http://back.homologa.educandus.com.br/",
  node: "https://educandus-node.herokuapp.com/",
  public: "http://back.homologa.educandus.com.br/",

  
  // LOCAL
  interface : 'http://127.0.0.1:8000/interface/interface.html',
  api : 'http://127.0.0.1:8000/api/',
  img : 'http://127.0.0.1:8000/',
  node: 'http://127.0.0.1:8000',
  node: 'https://educandus-node.herokuapp.com/',
  public: 'http://127.0.0.1:8000/',
  */

  interface: `${baseUrl}interface/interface.html`,
  api: `${baseUrl}api/`,
  img: baseUrl,
  node: window.BACKEND_NODE
    ? window.BACKEND_NODE
    : "https://educandus-node.herokuapp.com/",
  public: baseUrl,
  examMigrationAvaAdr: getExamMigrationUrl(),
  adrApi: getAdrApiUrl(),
  login: loginUrl
};
